// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"cf51fa49","361":"05303bfa","453":"a0ecbe00","608":"95472bfb","970":"70a93ffa"}[chunkId] + ".chunk.js";
};